import { jwtDecode } from "jwt-decode";
import { authenticatedFetch } from "@src/features/auth";
import { getEnvironment } from "@src/config/environment-store";
import { directory } from "@src/config/runtime";

/**
 * After login, trigger account linking for non-email Auth0 users.
 * Fires POST /api/v1/me/account-link which merges any duplicate email-connection
 * user into the caller's Microsoft/social identity.
 *
 * Never throws — a failed link attempt is not worth blocking the login flow.
 * The endpoint is idempotent so it safely retries on the next login.
 */
export async function triggerAccountLink(tokenResponse: { idToken?: string | null }): Promise<void> {
  try {
    const idToken = tokenResponse.idToken;
    if (!idToken) return;

    const payload = jwtDecode<{ sub?: string }>(idToken);
    if (!payload.sub || payload.sub.startsWith("email|")) return;

    const env = await getEnvironment();
    const baseUrl = directory(env);
    await authenticatedFetch(`${baseUrl}/api/v1/me/account-link`, { method: "POST" });
  } catch (error) {
    console.warn("[account-link] Failed to trigger account link (will retry on next login):", error);
  }
}
